module.exports = __webpack_public_path__ + "static/bairesdev-135398355c7addfb47e6d1b2ec6a1632.jpg";